
import Vue from 'vue';

/**
 * The composition meter from the token dialog redesign: a segmented bar showing what the balance
 * is MADE OF (each segment sized as its bucket's share), with one legend row per bucket in spend
 * order. Purely presentational — parents compute segments/rows (see utils/tokenBuckets.ts).
 *
 * Fills carry meaning (from the design handoff):
 * - monthly:  light amethyst gradient (monthly / daily tokens)
 * - rollover: striped purple — same hue as topup ("what kind"), striped ("expiring")
 * - topup:    solid purple (purchased this cycle)
 * - overage:  red (team over budget)
 */
export default Vue.extend({
	name: 'TokenCompositionMeter',
	props: {
		// [{ key, fill: 'monthly'|'rollover'|'topup'|'overage', widthPct }] — zero-width segments are skipped
		segments: { type: Array, default: () => [] },
		// [{ key, dot: fill|'track', label, qualifier, valueDisplay, dimmed, danger }]
		legendRows: { type: Array, default: () => [] },
	},
	computed: {
		visibleSegments (): any[] {
			return (this.segments as any[]).filter(({ widthPct }) => widthPct > 0.1);
		},
	},
});
